import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);


/**
 * Up arrow annimatie
 * 
 * 1. Functie voor het animeren naar de top van de pagina met ScrollTo
 * 2. detectie van de scroll hoogte: voeg class toe
 * 
 */
export function upArrow() {

  //haal de knop op uit de footer.html
  const backToTop =  document.getElementById('back-to-top');

  //click event op de knop afvangen
  backToTop.addEventListener('click', (e)=>{
    e.preventDefault();
    gsap.to(window, { duration: 1, scrollTo: 0, ease: 'power2' });
  })

  //Scroll positie
  let scrollpos = window.scrollY

  //update on scroll:
  window.addEventListener('scroll', function() { 
    scrollpos = window.scrollY;

    //add or remove class
    if (scrollpos >= 200 ) { backToTop.classList.add('show') }
    else { backToTop.classList.remove('show') }
  })
}

export function pinElement() {
  
  if (!document.body.classList.contains('single-vacatures') || document.documentElement.scrollWidth < 960) {
    return;
  }

  // console.log(document.documentElement.scrollWidth);

  //3. trigger voor de "pinned sidebar"
  ScrollTrigger.create({
    trigger: '.wp-block-column',
    start: 'top 150px',
    markers: false,
    // pin for the difference in heights between the content and the sidebar
    end: self => '+=' + (document.querySelector('.wp-block-column').offsetHeight -  self.pin.offsetHeight),
  // end: document.querySelector('.indrukwekkend-content').offsetHeight,
    pin: '.specificaties',
    // before version 3.4.1, the "float" property wasn't copied to the pin-spacer, so we manually do it here. Could do it in a style sheet instead if you prefer. 
  //onRefresh: self => self.pin.parentNode.style.float = 'left',
    pinSpacing: false,
  });
}

export function addElements(number = 20) {
  console.log('animation called');

  if ( !document.getElementsByClassName('is-style-indrukwekkend-animated') ) {
    return;
  }
  
  console.log('animation on page');

  //Quoteblokken met geanimeerde achtergrond
  // de spans worden geanimeerd met CSS, hier plaatsten we alleen een grote hoeveelheid spans
  var spanElements = document.createElement('div');

  var blocks = document.getElementsByClassName('is-style-indrukwekkend-animated');

  Array.prototype.forEach.call(blocks, function(block) {

    spanElements = document.createElement('div');
    spanElements.style.cssText = 'margin:0; isolation: isolate;';
    for (var i=0; i<number; i++) {
      spanElements.innerHTML += '<span></span>'
    }

    block.appendChild(spanElements);

  });
}
